import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';
import '../styles/AdminLogin.css';
import { setAuth } from '../auth';

function AdminLogin() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (apiError) setApiError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email || !formData.password) {
      setApiError('Please fill in all fields.');
      return;
    }

    setLoading(true);
    setApiError('');

    try {
      const res = await fetch(`${API_BASE_URL}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setApiError(typeof data?.detail === 'string' ? data.detail : 'Login failed');
        setLoading(false);
        return;
      }

      setAuth('admin', data.token, {
        role: 'admin',
        id: data.id,
        email: data.email,
      });
      navigate('/admin/dashboard');
    } catch {
      setApiError('Network error — please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="al-page">
      <div className="al-card">
        <div className="al-logo">SkillArea</div>
        <h1 className="al-title">Admin Login</h1>
        <p className="al-sub">Sign in to manage technician applications</p>

        <form onSubmit={handleSubmit} className="al-form">
          <div className="al-field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              autoComplete="email"
            />
          </div>

          <div className="al-field">
            <label htmlFor="password">Password</label>
            <div className="al-password-wrap">
              <input
                id="password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                value={formData.password}
                onChange={handleChange}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="al-toggle"
                onClick={() => setShowPassword((p) => !p)}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          {apiError && <p className="al-error">{apiError}</p>}

          <button type="submit" className="al-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <button className="al-back" onClick={() => navigate('/')}>
          &larr; Back to home
        </button>
      </div>
    </div>
  );
}

export default AdminLogin;
